import type { OsAccessLevel } from "@/lib/os-permissions";

export type AppSelectionEligibility = {
  eligible: boolean;
  reason: string | null;
};

export function getAppSelectionEligibility({
  effectiveLevel,
  isTemplate,
}: {
  effectiveLevel: OsAccessLevel;
  isTemplate: boolean;
}): AppSelectionEligibility {
  if (isTemplate) return { eligible: false, reason: "Templates cannot be deleted." };
  if (effectiveLevel !== "manager") {
    return { eligible: false, reason: "Only App managers can delete an App." };
  }
  return { eligible: true, reason: null };
}

export function toggleSelectedAppId(selectedIds: Set<string>, appId: string): Set<string> {
  const next = new Set(selectedIds);
  if (next.has(appId)) next.delete(appId); else next.add(appId);
  return next;
}

export function selectEligibleAppIds<T extends { id: string }>(
  selectedIds: Set<string>,
  apps: T[],
  isEligible: (app: T) => boolean,
): Set<string> {
  const next = new Set(selectedIds);
  const eligibleIds = apps.filter(isEligible).map((app) => app.id);
  const allSelected = eligibleIds.length > 0 && eligibleIds.every((id) => next.has(id));
  for (const id of eligibleIds) {
    if (allSelected) next.delete(id); else next.add(id);
  }
  return next;
}

export function pruneSelectedAppIds(selectedIds: Set<string>, apps: Array<{ id: string }>): Set<string> {
  const availableIds = new Set(apps.map((app) => app.id));
  return new Set([...selectedIds].filter((id) => availableIds.has(id)));
}
